export default __webpack_public_path__ + "f1607b3c37fe9c92818a394852452023.png";